import React, { PureComponent, PropTypes } from 'react';

import Confirm from './Confirm';
import Message from './Message';


const MESSAGE_TIME = 7000;

export default class FirstClockIn extends PureComponent {
  constructor(props) {
    super(props);
    this.showConfirm = this.showConfirm.bind(this);

    this.timer =
      setTimeout(this.showConfirm, MESSAGE_TIME, true);

    this.state = {
      showConfirm: false,
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  showConfirm(state) {
    this.setState({ showConfirm: state });
  }

  render() {
    return this.state.showConfirm ? (
      <Confirm
        key='confirm'
        clearUser={this.props.clearUser}
        signUpRecordConversion={this.props.signUpRecordConversion}
      />
    ) : (
      <Message
        key='message'
        setCanvas={this.props.setCanvas}
        features={this.props.features}
      />
    );
  }
}

FirstClockIn.propTypes = {
  clearUser: PropTypes.func.isRequired,
  features: PropTypes.object.isRequired,
  setCanvas: PropTypes.func.isRequired,
  signUpRecordConversion: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/FirstClockIn/index.jsx